import { Chip } from "components/DesignSystem/Chips/Chips";
import {
  Filter,
  MultiSelectFilter,
} from "components/DesignSystem/Filter/Filter";
import { PaginationHandler } from "components/DesignSystem/Pagination/Pagination";
import { useRoleBasedView } from "hooks/useRoleBasedView";

export default function ArchivedCrmFilter({
  tags,
  setShowTagModal,
  selectedTag,
  update,
  paginationData,
  selectedAgent,
  assignMembers,
  isFetching,
}) {
  const { isAdmin } = useRoleBasedView();
  const { isUserTypeForeignCA } = useRoleBasedView();

  const agentFilter = (values) => {
    if (values) {
      update({ query: "agent_filter", value: values.join(",") });
    } else {
      update({ query: "agent_filter", value: null });
    }
  };

  const updateTagFilter = (values) => {
    if (values) {
      update({ query: "tag_filter", value: values.join(",") });
    } else {
      update({ query: "tag_filter", value: null });
    }
  };

  const tagOptions = [
    { value: "NO_TAG", label: "No Tag" },
    ...(tags?.map((tag) => ({
      value: tag.title,
      label: `#${tag.title}`,
    })) || []),
  ];

  return (
    <>
      <div className="t-w-full">
        <div className="t-flex t-justify-between t-items-start t-mr-4">
          <div className="t-flex t-items-center t-flex-wrap t-gap-3">
            <Filter.Root
              defaultValue="TAG"
              title="Filter"
              capsule={
                <div className="t-flex t-gap-2 ">
                  {selectedTag?.split(",").length > 0 && (
                    <Chip
                      onRemove={() => updateTagFilter("")}
                      isActive
                      filterType="TAG"
                      className="t-rounded-3xl"
                    >
                      Tag ({selectedTag.split(",").length})
                    </Chip>
                  )}

                  {selectedAgent?.split(",").length > 0 && (
                    <Chip
                      onRemove={() => agentFilter("")}
                      isActive
                      filterType="AGENT"
                    >
                      Agent ({selectedAgent.split(",").length})
                    </Chip>
                  )}
                </div>
              }
            >
              <Filter.Portal>
                <Filter.List>
                  {!isUserTypeForeignCA && (
                    <Filter.ListItem value="TAG">Tag</Filter.ListItem>
                  )}
                  {isAdmin && (
                    <Filter.ListItem value="AGENT">Agent</Filter.ListItem>
                  )}
                </Filter.List>

                {!isUserTypeForeignCA && (
                  <Filter.Body value="TAG" block>
                    {tags && (
                      <MultiSelectFilter
                        onChange={updateTagFilter}
                        options={tagOptions}
                        selected={selectedTag?.split(",")}
                      />
                    )}
                  </Filter.Body>
                )}
                {isAdmin && (
                  <Filter.Body value="AGENT" block>
                    <MultiSelectFilter
                      onChange={agentFilter}
                      options={[
                        { value: "NOT_ASSIGNED", label: "Not Assigned" },
                        ...assignMembers?.map((assignee) => ({
                          value: assignee.profile_id,
                          label: assignee.name,
                        })),
                      ]}
                      selected={selectedAgent?.split(",")}
                    />
                  </Filter.Body>
                )}
              </Filter.Portal>
            </Filter.Root>
          </div>
          <PaginationHandler
            page_num={paginationData.currentPage}
            per_page={paginationData.itemsPerPage}
            total_count={paginationData.totalItemCount}
            total_pages={paginationData.totalPage}
            isLoading={isFetching}
            showLoadingText
          />
        </div>
      </div>
    </>
  );
}
